module.exports = __webpack_public_path__ + "img/logo.8dea9980.png";